// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Spinner from http://tobiasahlin.com/spinkit/*/
.cp-spinner {
	position:absolute;
	left:-webkit-calc(50% - 35px);
	left:-moz-calc(50% - 35px);
	left:calc(50% - 35px);
	top:-webkit-calc(50% - 31px);
	top:-moz-calc(50% - 31px);
	top:calc(50% - 31px);
	width: 70px;
	text-align: center;
	z-index: 999;
}
.cp-bouncer-red {
	background-color: #e53274;
}
.cp-bouncer-blue {
	background-color: #0a97f3;
}
.cp-bouncer-green {
	background-color: #61AB43;
}
.cp-spinner > div {
	width: 18px;
	height: 18px;
	border-radius: 100%;
	display: inline-block;
	-webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
	animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.cp-spinner .cp-bounce1 {
	-webkit-animation-delay: -0.32s;
	animation-delay: -0.32s;
}
.cp-spinner .cp-bounce2 {
	-webkit-animation-delay: -0.16s;
	animation-delay: -0.16s;
}
.cp-spinner > span {
	display: block;
	font-family: "Trebuchet MS", Verdana, Geneva, Arial, Helvetica, sans-serif;
	font-size: 18px;
	text-align: center;
	text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff;
}
@-webkit-keyframes sk-bouncedelay {
	0%, 80%, 100% { -webkit-transform: scale(0) }
	40% { -webkit-transform: scale(1.0) }
}
@keyframes sk-bouncedelay {
	0%, 80%, 100% {
		-webkit-transform: scale(0);
		transform: scale(0);
	} 40% {
		  -webkit-transform: scale(1.0);
		  transform: scale(1.0);
	  }
}`, "",{"version":3,"sources":["webpack://./node_modules/icos-cp-spinner/lib/styles.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;CACC,iBAAiB;CACjB,6BAA6B;CAC7B,0BAA0B;CAC1B,qBAAqB;CACrB,4BAA4B;CAC5B,yBAAyB;CACzB,oBAAoB;CACpB,WAAW;CACX,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,qBAAqB;CACrB,gEAAgE;CAChE,wDAAwD;AACzD;AACA;CACC,+BAA+B;CAC/B,uBAAuB;AACxB;AACA;CACC,+BAA+B;CAC/B,uBAAuB;AACxB;AACA;CACC,cAAc;CACd,0EAA0E;CAC1E,eAAe;CACf,kBAAkB;CAClB;;;;iBAIgB;AACjB;AACA;CACC,gBAAgB,4BAA4B;CAC5C,MAAM,8BAA8B;AACrC;AACA;CACC;EACC,2BAA2B;EAC3B,mBAAmB;CACpB,EAAE;IACC,6BAA6B;IAC7B,qBAAqB;GACtB;AACH","sourcesContent":["/*Spinner from http://tobiasahlin.com/spinkit/*/\n.cp-spinner {\n\tposition:absolute;\n\tleft:-webkit-calc(50% - 35px);\n\tleft:-moz-calc(50% - 35px);\n\tleft:calc(50% - 35px);\n\ttop:-webkit-calc(50% - 31px);\n\ttop:-moz-calc(50% - 31px);\n\ttop:calc(50% - 31px);\n\twidth: 70px;\n\ttext-align: center;\n\tz-index: 999;\n}\n.cp-bouncer-red {\n\tbackground-color: #e53274;\n}\n.cp-bouncer-blue {\n\tbackground-color: #0a97f3;\n}\n.cp-bouncer-green {\n\tbackground-color: #61AB43;\n}\n.cp-spinner > div {\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 100%;\n\tdisplay: inline-block;\n\t-webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n\tanimation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n.cp-spinner .cp-bounce1 {\n\t-webkit-animation-delay: -0.32s;\n\tanimation-delay: -0.32s;\n}\n.cp-spinner .cp-bounce2 {\n\t-webkit-animation-delay: -0.16s;\n\tanimation-delay: -0.16s;\n}\n.cp-spinner > span {\n\tdisplay: block;\n\tfont-family: \"Trebuchet MS\", Verdana, Geneva, Arial, Helvetica, sans-serif;\n\tfont-size: 18px;\n\ttext-align: center;\n\ttext-shadow:\n\t\t\t-1px -1px 0 #fff,\n\t\t\t1px -1px 0 #fff,\n\t\t\t-1px 1px 0 #fff,\n\t\t\t1px 1px 0 #fff;\n}\n@-webkit-keyframes sk-bouncedelay {\n\t0%, 80%, 100% { -webkit-transform: scale(0) }\n\t40% { -webkit-transform: scale(1.0) }\n}\n@keyframes sk-bouncedelay {\n\t0%, 80%, 100% {\n\t\t-webkit-transform: scale(0);\n\t\ttransform: scale(0);\n\t} 40% {\n\t\t  -webkit-transform: scale(1.0);\n\t\t  transform: scale(1.0);\n\t  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
